/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8.97723 18.8681C8.61252 18.8003 8.26555 18.7063 7.92983 18.5862C7.20097 18.3255 6.83653 18.1951 6.69669 18.1622C5.40646 17.8588 4.87122 18.7431 3.7592 18.9284C3.21302 19.0194 2.72704 18.5722 2.77236 18.0203C2.812 17.5378 3.14571 17.0814 3.27886 16.6181C3.55569 15.6548 3.18005 14.9244 2.78319 14.0677C2.28062 12.9828 2 11.7742 2 10.5C2 5.80558 5.80558 2 10.5 2C13.5419 2 16.2105 3.59785 17.7124 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17 21C13.6863 21 11 18.3137 11 15C11 11.6863 13.6863 9 17 9C20.3137 9 23 11.6863 23 15C23 15.8994 22.8019 16.7526 22.4472 17.5184C22.167 18.1231 21.9019 18.6387 22.0973 19.3186C22.1913 19.6457 22.4268 19.9679 22.4548 20.3085C22.4868 20.698 22.1437 21.0137 21.7582 20.9494C20.9733 20.8186 20.5954 20.1945 19.6847 20.4086C19.586 20.4319 19.3287 20.5239 18.8142 20.7079C18.2699 20.9026 17.6836 21 17 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M17 21C13.6863 21 11 18.3137 11 15C11 11.6863 13.6863 9 17 9C20.3137 9 23 11.6863 23 15C23 15.8994 22.8019 16.7526 22.4472 17.5184C22.167 18.1231 21.9019 18.6387 22.0973 19.3186C22.1913 19.6457 22.4268 19.9679 22.4548 20.3085C22.4868 20.698 22.1438 21.0137 21.7582 20.9494C20.9733 20.8186 20.5954 20.1945 19.6847 20.4086C19.586 20.4319 19.3287 20.5239 18.8142 20.7079C18.2699 20.9026 17.6836 21 17 21Z"
				fill="currentColor"
			/>
			<path
				d="M8.97723 18.8681C8.61252 18.8003 8.26555 18.7063 7.92983 18.5862C7.20097 18.3255 6.83653 18.1951 6.69669 18.1622C5.40646 17.8588 4.87122 18.7431 3.7592 18.9284C3.21302 19.0194 2.72704 18.5722 2.77236 18.0203C2.812 17.5378 3.14571 17.0814 3.27886 16.6181C3.55569 15.6548 3.18005 14.9244 2.78319 14.0677C2.28062 12.9828 2 11.7742 2 10.5C2 5.80558 5.80558 2 10.5 2C13.5419 2 16.2105 3.59785 17.7124 6M11 15C11 18.3137 13.6863 21 17 21C17.6836 21 18.2699 20.9026 18.8142 20.7079C19.3287 20.5239 19.586 20.4319 19.6847 20.4086C20.5954 20.1945 20.9733 20.8186 21.7582 20.9494C22.1437 21.0137 22.4868 20.698 22.4548 20.3085C22.4268 19.9679 22.1913 19.6457 22.0973 19.3186C21.9019 18.6387 22.167 18.1231 22.4472 17.5184C22.8019 16.7526 23 15.8994 23 15C23 11.6863 20.3137 9 17 9C13.6863 9 11 11.6863 11 15Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M8.04946 1.75442C11.7066 0.70665 16.0159 1.72939 18.3562 5.64338C18.5001 5.88413 18.4977 6.18509 18.3499 6.42349C18.202 6.66189 17.9335 6.79787 17.6539 6.77597C12.9375 6.40661 8.75 10.2563 8.75 15.0005C8.75 16.2629 9.03304 17.4571 9.53842 18.525C9.65989 18.7817 9.62599 19.0849 9.45083 19.3084C9.27567 19.532 8.9893 19.6374 8.71103 19.5808C8.35395 19.5082 8.01079 19.4122 7.67722 19.2929C7.29751 19.157 6.91626 18.9942 6.525 18.8928C6.10656 18.7944 5.83146 18.8743 5.48304 19.0399C5.15299 19.1968 4.5761 19.5531 3.88246 19.6686C2.85435 19.8399 1.93956 18.9982 2.02488 17.9594C2.07229 17.3822 2.40428 16.9464 2.55804 16.4114C2.74338 15.7665 2.52822 15.302 2.11145 14.4024L2.10266 14.3834C1.5553 13.2018 1.25 11.8858 1.25 10.5005C1.25 5.95571 4.39451 2.80157 8.04946 1.75442Z"
				fill="currentColor"
			/>
			<path
				d="M10.25 15.0003C10.25 11.2724 13.2721 8.25032 17 8.25032C20.7279 8.25032 23.75 11.2724 23.75 15.0003C23.75 16.0109 23.5272 16.9715 23.1277 17.8339C22.8219 18.4941 22.7129 18.7457 22.8181 19.1118C22.9308 19.504 23.1673 19.8218 23.2023 20.2474C23.2743 21.1239 22.5024 21.8341 21.635 21.6896C21.1048 21.6012 20.6491 21.3236 20.4467 21.2274C20.226 21.1225 20.0851 21.0853 19.8565 21.139C19.5891 21.2147 19.3282 21.3209 19.0668 21.4144C18.4313 21.6418 17.7583 21.7503 17 21.7503C13.2721 21.7503 10.25 18.7282 10.25 15.0003Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8.97723 18.8681C8.61252 18.8003 8.26555 18.7063 7.92983 18.5862C7.20097 18.3255 6.83653 18.1951 6.69669 18.1622C5.40646 17.8588 4.87122 18.7431 3.7592 18.9284C3.21302 19.0194 2.72704 18.5722 2.77236 18.0203C2.812 17.5378 3.14571 17.0814 3.27886 16.6181C3.55569 15.6548 3.18005 14.9244 2.78319 14.0677C2.28062 12.9828 2 11.7742 2 10.5C2 5.80558 5.80558 2 10.5 2C13.5419 2 16.2105 3.59785 17.7124 6M15 9.34141C15.6256 9.12031 16.2987 9 17 9C20.3137 9 23 11.6863 23 15C23 15.8994 22.8019 16.7526 22.4472 17.5184C22.167 18.1231 21.9019 18.6387 22.0973 19.3186C22.1913 19.6457 22.4268 19.9679 22.4548 20.3085C22.4868 20.698 22.1437 21.0137 21.7582 20.9494C20.9733 20.8186 20.5954 20.1945 19.6847 20.4086C19.586 20.4319 19.3287 20.5239 18.8142 20.7079C18.2699 20.9026 17.6836 21 17 21C13.6863 21 11 18.3137 11 15C11 13.9071 11.2922 12.8825 11.8027 12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8.97723 18.8681C8.61252 18.8003 8.26555 18.7063 7.92983 18.5862C7.20097 18.3255 6.83653 18.1951 6.69669 18.1622C5.40646 17.8588 4.87122 18.7431 3.7592 18.9284C3.21302 19.0194 2.72704 18.5722 2.77236 18.0203C2.812 17.5378 3.14571 17.0814 3.27886 16.6181C3.55569 15.6548 3.18005 14.9244 2.78319 14.0677C2.28062 12.9828 2 11.7742 2 10.5C2 5.80558 5.80558 2 10.5 2C13.5419 2 16.2105 3.59785 17.7124 6M11 15C11 18.3137 13.6863 21 17 21C17.6836 21 18.2699 20.9026 18.8142 20.7079C19.3287 20.5239 19.586 20.4319 19.6847 20.4086C20.5954 20.1945 20.9733 20.8186 21.7582 20.9494C22.1437 21.0137 22.4868 20.698 22.4548 20.3085C22.4268 19.9679 22.1913 19.6457 22.0973 19.3186C21.9019 18.6387 22.167 18.1231 22.4472 17.5184C22.8019 16.7526 23 15.8994 23 15C23 11.6863 20.3137 9 17 9C13.6863 9 11 11.6863 11 15Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M8.04946 1.75442C11.7066 0.70665 16.0159 1.72939 18.3562 5.64338C18.5001 5.88413 18.4977 6.18509 18.3499 6.42349C18.202 6.66189 17.9335 6.79787 17.6539 6.77597C12.9375 6.40661 8.75 10.2563 8.75 15.0005C8.75 16.2629 9.03304 17.4571 9.53842 18.525C9.65989 18.7817 9.62599 19.0849 9.45083 19.3084C9.27567 19.532 8.9893 19.6374 8.71103 19.5808C8.35395 19.5082 8.01079 19.4122 7.67722 19.2929C7.29751 19.157 6.91626 18.9942 6.525 18.8928C6.10656 18.7944 5.83146 18.8743 5.48304 19.0399C5.15299 19.1968 4.5761 19.5531 3.88246 19.6686C2.85435 19.8399 1.93956 18.9982 2.02488 17.9594C2.07229 17.3822 2.40428 16.9464 2.55804 16.4114C2.74338 15.7665 2.52822 15.302 2.11145 14.4024L2.10266 14.3834C1.5553 13.2018 1.25 11.8858 1.25 10.5005C1.25 5.95571 4.39451 2.80157 8.04946 1.75442Z"
				fill="currentColor"
			/>
			<path
				d="M10.25 15.0005C10.25 11.2726 13.2721 8.25049 17 8.25049C20.7279 8.25049 23.75 11.2726 23.75 15.0005C23.75 16.0111 23.5272 16.9716 23.1277 17.8341C22.8219 18.4942 22.7129 18.7458 22.8181 19.112C22.9308 19.5042 23.1673 19.822 23.2023 20.2476C23.2743 21.124 22.5024 21.8342 21.635 21.6897C21.1048 21.6014 20.6491 21.3237 20.4467 21.2276C20.226 21.1227 20.0851 21.0854 19.8565 21.1392C19.5891 21.2149 19.3282 21.3211 19.0668 21.4146C18.4313 21.6419 17.7583 21.7505 17 21.7505C13.2721 21.7505 10.25 18.7284 10.25 15.0005Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
